import api from '~config/api';

const SizesAndCrustsService = {
  getSizesAndCrusts: () => api.get('/v2/sizes_and_crusts')
};

export default SizesAndCrustsService;
